module.exports = __webpack_public_path__ + "img/table.215c94c3.png";